import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { base_url } from "../utils/baseUrl";
import { useFormik } from "formik";
import axios from "axios";
import Loader from "../utils/loder";

let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  cname: yup.string().required("compny name is Required"),
  email: yup.string().required("email is Required"),
  phone: yup.string().required("phone is Required"),
  address: yup.string().required("address is Required"),
});
const AddNewscat = () => {
  const navigate = useNavigate();
  const [imageErrorone, setImageErrorone] = useState("");
  const [imageErrortwo, setImageErrortwo] = useState("");
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      cname: "",
      email: "",
      phone: "",
      country: "",
      address: "",

    },
    validationSchema: schema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        
        const response = await axios.post(`${base_url}uffta/createUFFTA`, values);
        setLoading(false);
        alert("Form submitted successfully!");
        // Handle response
        window.location.reload();

        // Optionally, navigate to another page upon successful submission
        // Navigate to a success page
      } catch (error) {
        setLoading(false);
        alert("Something Went Wrong");
        console.log("API Error:", error);
      }
    },
  });
  return (

    <div className="container">
      {loading ? (
            <Loader color="#00BFFF" height={50} width={50} />
          ) : (
      <div className="box-container" style={{ border: "5px solid blue", boxShadow: "0 0 50px red" }}>
        <h1 className="mb-4  title" style={{ marginTop: "50px" }}>
        United Federation of Travel Agents Associations
        </h1>
        <h3 className="mb-4  title">
        Member Registration Form
        </h3>
        <div>
          
            <form action="" onSubmit={formik.handleSubmit}>
              <CustomInput
                type="text"
                name="name"
                onChng={formik.handleChange("name")}
                onBlr={formik.handleBlur("name")}
                val={formik.values.name}
                label="Enter Name"
              />
              <div className="error">
                {formik.touched.name && formik.errors.name}
              </div>


              <CustomInput
                type="text"
                label="Enter Compny Name"
                name="cname"
                onChng={formik.handleChange("cname")}
                onBlr={formik.handleBlur("cname")}
                val={formik.values.cname}
              />
              <div className="error">{formik.touched.cname && formik.errors.cname}</div>


              <CustomInput
                type="text"
                label="Enter email"
                name="city"
                onChng={formik.handleChange("email")}
                onBlr={formik.handleBlur("email")}
                val={formik.values.email}
              />
              <div className="error">{formik.touched.email && formik.errors.email}</div>


              <CustomInput
                type="text"
                label="Enter phone"
                name="phone"
                onChng={formik.handleChange("phone")}
                onBlr={formik.handleBlur("phone")}
                val={formik.values.phone}
              />
              <div className="error">{formik.touched.phone && formik.errors.phone}</div>

              <CustomInput
                type="text"
                label="Enter Address"
                name="address"
                onChng={formik.handleChange("address")}
                onBlr={formik.handleBlur("address")}
                val={formik.values.address}
              />
              <div className="error">{formik.touched.address && formik.errors.address}</div>

              

              <div className="text-center mt-3">

                <button
                  className="btn btn-success border-0 rounded-3 my-5"
                  type="submit"
                >
                  Submit
                </button>

              </div>
            </form>
          
        </div>
      </div>
      )}
    </div>

  );
};

export default AddNewscat;
